import {Component} from '@angular/core';
import {FeatureTypeService} from '@catcore/services';
import {EntitySchemaService} from '@catcore/services/entity-schema.service';
import {Feature} from '@catcore/services/feature/feature';
import {DefaultLanding} from '@catfeatures/shared/default-landing';

const EntitySchemaTypeRef = 'FeaturePorts';
const selfTitle = 'Feature Ports';

@Component({
  templateUrl: './feature-ports-landing.component.html',
})
export class FeaturePortsLandingComponent extends DefaultLanding {

  constructor(schemaService: EntitySchemaService,
              featureService: FeatureTypeService) {
    super(schemaService, featureService);
    this.setSelfTitle(selfTitle);
  }

  getEntitySchemaTypeRef() {
    return EntitySchemaTypeRef;
  }

  getRelatedItems(feature: Feature) {
    return this.getFeatureService().extractPortsFor(feature);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/features/components/landing-pages/feature-ports-landing/feature-ports-landing.component.ts